import * as twgl from 'twgl.js';

import { Rndm } from './Rndm.js';
import { Arry } from './Arry.js';

import { wbgl_type } from './Wbgl.js';

export interface shdr_manager_type {
    list: shdr_type[];
    make: (canvas: wbgl_type, io: any) => shdr_type;
    get: (id: string) => shdr_type;
}

export interface shdr_type {
    id: string;
    compiled: twgl.ProgramInfo;
    vertex: string;
    fragment: string;
    [key: string]: any;
}

export const Shdr: shdr_manager_type = {
    list: [] as shdr_type[],
    make: function (canvas: wbgl_type, io: any): shdr_type {

        if (io.id && this.get(io.id)) console.log("SHADER already exists: " + io.id);

        const s: shdr_type = {
            ...io,
            id: io.id || Rndm.id("shdr_"),
            compiled: twgl.createProgramInfo(canvas.context, [io.vertex, io.fragment]),
            vertex: io.vertex,
            fragment: io.fragment
        };
        Shdr.list.push(s);
        return s;
    },
    get: function (id: string): shdr_type {
        return Arry.get.id(this.list, id);
    }
};
